// import { Link } from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';
import {Link, Navigate} from "react-router-dom";
import PmsUrlConfig from '../../urlConfig';
import { Modal} from 'react-bootstrap';
import {useState, useEffect} from 'react';
import ErrorBoundary from '../ErrorBoundary';
import {getPractice, getServiceTypeLabel} from '../common';
import {EditServiceIcon} from './EditServiceIcon.tsx';

import AddServiceLocation from './AddServiceLocation';
import EditServiceLocation from './EditServiceLocation';

export default function ViewServices() {
    const dispatch = useDispatch();

    const [showAddService, setShowAddService] = useState(false);
    const [showEditService, setShowEditService] = useState(false);
    const [showHelpModal, setShowHelpModal] = useState(false);

    const [selectedServiceId, setSelectedServiceId] = useState('');
    const practiceDetails = useSelector(state => state.practiceDetails);
    const loginDetails = useSelector(state => state.loginDetails);

    if (!practiceDetails || practiceDetails.practice == null)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`}/>

    const practice = practiceDetails.practice;
    
    var token = "";
    var serviceTypes = [];
    if (loginDetails) {
        token = loginDetails.jwtToken;
        serviceTypes = loginDetails.serviceTypes;
    }

    // Fetch fresh practice data when component mounts or when practice ID/token changes
    useEffect(() => {
        if (practice && practice._id && token) {
            getPractice(practice._id, dispatch, token);
        }
    }, [practice?._id, token, dispatch]); // Dependencies: refetch when practice ID or token changes

    const practiceUsers = practice.user
    if (practiceUsers == null) {
        return (
            <div><p>No Users Found</p></div>
        )
    }

    const handleSelectedService = (selectedServiceId) => {
        setSelectedServiceId(selectedServiceId)
        practice.practice_service.forEach((pService) => {
            if (pService._id === selectedServiceId) {
                // Convert service types to react-select format before dispatching
                const serviceTypesForSelect = pService.service_types.map(st => ({
                    value: st.service_code,
                    label: st.service_name || st.service_code
                }));
                
                dispatch({
                    type: 'selectService',
                    payload: pService
                });
                dispatch({
                    type: 'serviceTypeChange',
                    payload: serviceTypesForSelect  // Use converted format
                });
                handleEditServiceShow();
                return
            }
        })
    }

    const handleAddServiceShow = () => {
        dispatch({
            type: 'clearMsg'
        });
        setShowAddService(true);
    }
    const handleEditServiceShow = () => {
        if (selectedServiceId === null || selectedServiceId === '') {
            return
        }
        dispatch({
            type: 'clearMsg'
        });
        setShowEditService(true);
    }


    const handleAddServiceClose = () => {
        setShowAddService(false);
        dispatch({
            type: 'clearMsg'
        })
        getPractice(practice._id, dispatch, token);
    }

    const handleEditServiceClose = () => {
        setShowEditService(false);
        dispatch({
            type: 'clearMsg'
        })
        getPractice(practice._id, dispatch, token);
    }


    return (
        <div className="w-full">
            {/* Header Section */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2.5 sm:gap-4 mb-6 sm:min-h-[72px] lg:h-[91px]">
                <h1 className="text-xl font-bold text-gray-900">Service Locations</h1>
                <div className="flex gap-3">
                    <button 
                        onClick={handleAddServiceShow}
                        className="px-6 py-2.5 bg-[#0B6D76] hover:bg-[#0A5A62] text-white font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2"
                        data-testid="add-service-button"
                    >
                        + Add New
                    </button>
                    <button
                        onClick={() => setShowHelpModal(true)}
                        className="px-6 py-2.5 inline-flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Help
                    </button>
                </div>
            </div>
            
            {/* Desktop Table View */}
            <div className='hidden lg:block'>
                <div className='bg-white rounded-xl shadow-lg overflow-hidden'>
                    <div className='overflow-x-auto'>
                        <table className='w-full'>
                            <thead>
                                <tr className='border-b border-gray-200 bg-gray-50'>
                                    <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>Name</th>
                                    <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>Location</th>
                                    <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>Services</th>
                                    <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>Phone Number</th>
                                    <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>Action</th>
                                </tr>
                            </thead>
                            <tbody className='divide-y divide-gray-200'>
                                {practice.practice_service != null && practice.practice_service.map((pService, index) => (
                                    <>
                                        {!pService.is_deleted && (
                                            <tr key={index} className='hover:bg-gray-50 transition-colors'>
                                                <td className='px-6 py-4'>
                                                    <div>
                                                        <p className='text-sm font-semibold text-gray-900'>{pService.location_name}</p>
                                                    </div>
                                                </td>
                                                <td className='px-6 py-4'>
                                                    <div className='text-sm text-gray-900'>
                                                        <div>{pService.service_address.street1}{pService.service_address.street2 && ', ' + pService.service_address.street2}</div>
                                                        <div>{pService.service_address.city}</div>
                                                        <div>{pService.service_address.state}</div>
                                                        <div>{pService.service_address.zip_code}</div>
                                                    </div>
                                                </td>
                                                <td className='px-6 py-4'>
                                                    <div className="text-sm text-gray-900">
                                                        {pService.service_types && pService.service_types.filter(serv => serv.service_code).map((serv) => {
                                                            const label = getServiceTypeLabel(serv.service_code, serviceTypes);
                                                            return (
                                                                <div key={serv.service_code} className="mb-1">
                                                                    • {label}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </td>
                                                <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-500'>
                                                    {/* Phone Number */}
                                                </td>
                                                <td className='px-6 py-4 whitespace-nowrap'>
                                                    <Link 
                                                        onClick={() => handleSelectedService(pService._id)}
                                                        className='inline-flex items-center justify-center w-10 h-10 rounded-lg hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2'
                                                    >
                                                        <EditServiceIcon className='w-8 h-8 text-gray-600 transform -rotate-90' />
                                                    </Link>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Mobile Card View */}
            <div className='lg:hidden space-y-4'>
                {practice.practice_service != null && practice.practice_service.map((pService, index) => (
                                    <>
                                        {!pService.is_deleted && (
                                            <div key={index} className='bg-white rounded-xl shadow-lg p-4 hover:shadow-xl transition-shadow'>
                                                <div className='flex items-start justify-between mb-3'>
                                                    <div className='flex-1'>
                                                        <h3 className='text-base font-semibold text-gray-900'>
                                                            {pService.location_name}
                                                        </h3>
                                                    </div>
                                                    <Link
                                                        onClick={() => handleSelectedService(pService._id)}
                                                        className='ml-3 inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2'
                                                    >
                                                        <EditServiceIcon className='w-4 h-4 text-gray-600 transform -rotate-90' />
                                                    </Link>
                                                </div>
                                                
                                                <div className='space-y-2'>
                                                    <div className='flex items-center text-sm'>
                                                        <span className='text-gray-500 font-medium w-24'>Location:</span>
                                                        <span className='text-gray-700'>{pService.service_address.street1}{pService.service_address.street2 && ', ' + pService.service_address.street2}</span>
                                                    </div>
                                                    <div className='flex items-center text-sm'>
                                                        <span className='text-gray-500 font-medium w-24'>City:</span>
                                                        <span className='text-gray-700'>{pService.service_address.city}</span>
                                                    </div>
                                                    <div className='flex items-center text-sm'>
                                                        <span className='text-gray-500 font-medium w-24'>State:</span>
                                                        <span className='text-gray-700'>{pService.service_address.state}</span>
                                                    </div>
                                                    <div className='flex items-center text-sm'>
                                                        <span className='text-gray-500 font-medium w-24'>Zip:</span>
                                                        <span className='text-gray-700'>{pService.service_address.zip_code}</span>
                                                    </div>
                                                    <div className='flex items-center'>
                                                        <span className='text-gray-500 font-medium text-sm w-24'>Services:</span>
                                                        <div className="text-sm text-gray-700">
                                                            {pService.service_types && pService.service_types.filter(serv => serv.service_code).map((serv) => {
                                                                const label = getServiceTypeLabel(serv.service_code, serviceTypes);
                                                                return (
                                                                    <div key={serv.service_code} className="mb-1">
                                                                        • {label}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                ))}
                            </div>
                    
                    {/* Modals */}
                    <Modal show={showAddService} onHide={handleAddServiceClose} size='xl' backdrop="static">
                        <Modal.Header closeButton className="border-b border-gray-200">
                            <Modal.Title><h2 className="text-xl font-semibold text-gray-900">Add Service Location</h2></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-6">
                            <ErrorBoundary>
                                <AddServiceLocation updateFlag={false} onSuccess={handleAddServiceClose} />
                            </ErrorBoundary>
                        </Modal.Body>
                        
                    </Modal>
                    
                    <Modal show={showEditService} onHide={handleEditServiceClose} size='xl' backdrop="static">
                        <Modal.Header closeButton className="border-b border-gray-200">
                            <Modal.Title><h2 className="text-xl font-semibold text-gray-900">Edit Service Location</h2></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-6">
                            <ErrorBoundary>
                                <EditServiceLocation updateFlag={true} onSuccess={handleEditServiceClose} />
                            </ErrorBoundary>
                        </Modal.Body>
                    </Modal>

                    {/* Help Modal - How to Set Up Locations */}
                    <Modal show={showHelpModal} onHide={() => setShowHelpModal(false)} size='lg' centered>
                        <Modal.Header closeButton className="border-b border-gray-200">
                            <Modal.Title><h2 className="text-2xl font-bold text-gray-900">How to Set Up Locations</h2></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-6">
                            <div className="space-y-4 text-gray-700">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Practice Activation</h3>
                                    <p className="leading-relaxed">
                                        Practice must set up at least one location to become active.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Enter Location Address</h3>
                                    <p className="leading-relaxed">
                                        Enter the location address.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Add Services</h3>
                                    <p className="leading-relaxed">
                                        Add the services provided at that location. You can add more than one service by simply clicking on each service.
                                    </p>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="border-t border-gray-200">
                            <button
                                onClick={() => setShowHelpModal(false)}
                                className="px-6 py-2.5 bg-[#0B6D76] hover:bg-[#0A5A62] text-white font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2"
                            >
                                Close
                            </button>
                        </Modal.Footer>
                    </Modal>
        </div>
    );
}